import { OrganizationFormValues } from "../OrganizationForm/types";

export const initialOrganizationValues: OrganizationFormValues = {
  input: {
    name: "",
  },
};
